(() => {
  const init = (root = document) => {
    root.querySelectorAll('.nc-cookie-open:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const message = button.parentElement.querySelector('.nc-cookie-message');
        if (message) message.hidden = true;
        const banner = window.privacyBanner || window.Shopify?.privacyBanner;
        try {
          if (!banner?.showPreferences) throw new Error('Banner not loaded');
          await banner.showPreferences();
        } catch (_) { if (message) message.hidden = false; }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
